package ai.flowstorm.studio.ui.form

import ai.flowstorm.studio.resources.space.StyleResource
import io.kvision.form.select.Select
import io.kvision.core.StringPair
import io.kvision.i18n.tr

class StyleSelect: Select(
    label = tr("Style"),
    options = StyleResource.loadPredefinedStyles().map { StringPair(it.name.lowercase(), it.name) }
)